import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=766f3e1e&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=766f3e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f3e1e",
  null
  
)

export default component.exports